import CloseIcon from '@clearkit/icons/glyphs/Close';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import { CKTab, CKTabList, CKTabPanel, CKTabPanels, CKTabs } from 'clearkit';
import { useState } from 'react';

import AccountPlan from './AccountPlan';
import FeatureFlags from './FeatureFlags';

export default function DeveloperPanel(props) {
  const { onClose, ...rest } = props;
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Drawer {...rest} onClose={onClose} anchor="bottom" height={500}>
      <div className="relative">
        <IconButton
          className="absolute w-10 h-10 -ml-20 -top-5 -right-3"
          onClick={onClose}>
          <div className="p-4 bg-white border rounded-full shadow-lg">
            <CloseIcon />
          </div>
        </IconButton>

        <div className="m-8 -mt-4 overflow-x-hidden overflow-y-auto h-96">
          <CKTabs index={tabIndex} onChange={setTabIndex} isBordered>
            <CKTabList aria-label="My tabs">
              <CKTab label="Feature Flags">Feature Flags</CKTab>
              <CKTab label="Account Plans">Account Plans</CKTab>
            </CKTabList>
            <CKTabPanels>
              <CKTabPanel>
                <div className="py-4">
                  <FeatureFlags />
                </div>
              </CKTabPanel>
              <CKTabPanel>
                <div className="py-4">
                  <AccountPlan />
                </div>
              </CKTabPanel>
            </CKTabPanels>
          </CKTabs>
        </div>
      </div>
    </Drawer>
  );
}
